// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import { GroupDetailsFragmentDoc } from '../Features/Grupper/Groups.graphql-gen';
import { FeatureFlagDetailsFragmentDoc } from '../Features/Feature flags/FeatureFlags.graphql-gen';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { users?: Array<{ userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> }> };

export type UserListFragment = { userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> };

export type PaginateUsersQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  startIndex?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  UserFilter?: Types.InputMaybe<Types.UserFilter>;
}>;


export type PaginateUsersQuery = { paginatedUsers?: { total?: unknown, items?: Array<{ userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> }> } };

export type GridOwnersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GridOwnersQuery = { gridOwners?: Array<string> };

export type GetUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type GetUserQuery = { user?: { userId?: string, name?: string, nickname?: string, firstName?: string, idProviderSubject?: string, lastName?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, lastUpdated?: string, groups?: Array<{ id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> }>, fjutter?: Array<{ anleggsId?: string, deviceId?: string }>, devices?: Array<{ appVersion?: string, deviceId: string, manufacturer?: string, model?: string, operatingSystem?: string, osVersion?: string, platform?: string, pushNotificationToken?: string, name?: string, lastSeen?: string, notificationsDisabled?: boolean }>, meters?: Array<{ meterId?: string, meteringPointId?: string, gridOwner?: string, priceZone?: Types.ElectricityPriceZone, alias?: string, address?: { streetAddress?: string, postalCode?: string, postalPlace?: string }, owner?: { type?: Types.OwnerType, nameOfOwner?: string }, scaling?: { factor?: number, fromDate?: string, validated?: string }, classification?: { classification?: Types.ClassificationType, consumptionCode?: string }, electricityContracts?: Array<{ dateFrom?: string, dateTo?: string, productName?: string, productCode?: string, description?: string, status?: Types.ContractStatus, products?: Array<{ name?: string, code?: string, from?: string, to?: string }> }> }>, ownedContracts?: Array<{ _id?: string, accountGuid?: string, status?: string, customerGuid?: string, meterNumber?: string, meterPointId?: string, accountingPointGuid?: string, product?: string, lastUpdated?: string }>, sharedContracts?: Array<{ _id?: string, accountGuid?: string, status?: string, customerGuid?: string, meterNumber?: string, meterPointId?: string, accountingPointGuid?: string, product?: string, lastUpdated?: string }> } };

export type UserDetailsFragment = { userId?: string, name?: string, nickname?: string, firstName?: string, idProviderSubject?: string, lastName?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, lastUpdated?: string, fjutter?: Array<{ anleggsId?: string, deviceId?: string }>, devices?: Array<{ appVersion?: string, deviceId: string, manufacturer?: string, model?: string, operatingSystem?: string, osVersion?: string, platform?: string, pushNotificationToken?: string, name?: string, lastSeen?: string, notificationsDisabled?: boolean }>, meters?: Array<{ meterId?: string, meteringPointId?: string, gridOwner?: string, priceZone?: Types.ElectricityPriceZone, alias?: string, address?: { streetAddress?: string, postalCode?: string, postalPlace?: string }, owner?: { type?: Types.OwnerType, nameOfOwner?: string }, scaling?: { factor?: number, fromDate?: string, validated?: string }, classification?: { classification?: Types.ClassificationType, consumptionCode?: string }, electricityContracts?: Array<{ dateFrom?: string, dateTo?: string, productName?: string, productCode?: string, description?: string, status?: Types.ContractStatus, products?: Array<{ name?: string, code?: string, from?: string, to?: string }> }> }>, ownedContracts?: Array<{ _id?: string, accountGuid?: string, status?: string, customerGuid?: string, meterNumber?: string, meterPointId?: string, accountingPointGuid?: string, product?: string, lastUpdated?: string }>, sharedContracts?: Array<{ _id?: string, accountGuid?: string, status?: string, customerGuid?: string, meterNumber?: string, meterPointId?: string, accountingPointGuid?: string, product?: string, lastUpdated?: string }> };

export type ContractDetailsFragment = { _id?: string, accountGuid?: string, status?: string, customerGuid?: string, meterNumber?: string, meterPointId?: string, accountingPointGuid?: string, product?: string, lastUpdated?: string };

export type MeterDetailsFragment = { meterId?: string, meteringPointId?: string, gridOwner?: string, priceZone?: Types.ElectricityPriceZone, alias?: string, address?: { streetAddress?: string, postalCode?: string, postalPlace?: string }, owner?: { type?: Types.OwnerType, nameOfOwner?: string }, scaling?: { factor?: number, fromDate?: string, validated?: string }, classification?: { classification?: Types.ClassificationType, consumptionCode?: string }, electricityContracts?: Array<{ dateFrom?: string, dateTo?: string, productName?: string, productCode?: string, description?: string, status?: Types.ContractStatus, products?: Array<{ name?: string, code?: string, from?: string, to?: string }> }> };

export type DeviceDetailsFragment = { appVersion?: string, deviceId: string, manufacturer?: string, model?: string, operatingSystem?: string, osVersion?: string, platform?: string, pushNotificationToken?: string, name?: string, lastSeen?: string, notificationsDisabled?: boolean };

export type DeleteUserMutationVariables = Types.Exact<{
  userid: Types.Scalars['String']['input'];
}>;


export type DeleteUserMutation = { deleteUser: boolean };

export type SyncUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type SyncUserMutation = { syncUser?: { success: boolean, userId?: string } };

export type RemoveFjuttFromUserMutationVariables = Types.Exact<{
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  fjuttId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RemoveFjuttFromUserMutation = { removeFjuttFromUser: boolean };

export type DeleteDeviceMutationVariables = Types.Exact<{
  userid: Types.Scalars['String']['input'];
  deviceid: Types.Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { deleteDevice: boolean };

export const UserListFragmentDoc = gql`
    fragment UserList on User {
  userId
  name
  nickname
  mobileNumber
  emailAddress
  birthDate
  groupIds
}
    `;
export const DeviceDetailsFragmentDoc = gql`
    fragment DeviceDetails on Device {
  appVersion
  deviceId
  manufacturer
  model
  operatingSystem
  osVersion
  platform
  pushNotificationToken
  name
  lastSeen
  notificationsDisabled
}
    `;
export const MeterDetailsFragmentDoc = gql`
    fragment MeterDetails on Meter {
  meterId
  meteringPointId
  gridOwner
  priceZone
  alias
  address {
    streetAddress
    postalCode
    postalPlace
  }
  owner {
    type
    nameOfOwner
  }
  scaling {
    factor
    fromDate
    validated
  }
  classification {
    classification
    consumptionCode
  }
  electricityContracts {
    dateFrom
    dateTo
    productName
    productCode
    description
    status
    products {
      name
      code
      from
      to
    }
  }
}
    `;
export const ContractDetailsFragmentDoc = gql`
    fragment ContractDetails on Contract {
  _id
  accountGuid
  status
  customerGuid
  meterNumber
  meterPointId
  accountingPointGuid
  product
  lastUpdated
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  userId
  name
  nickname
  firstName
  idProviderSubject
  lastName
  mobileNumber
  emailAddress
  birthDate
  lastUpdated
  fjutter {
    anleggsId
    deviceId
  }
  devices {
    ...DeviceDetails
  }
  meters {
    ...MeterDetails
  }
  ownedContracts {
    ...ContractDetails
  }
  sharedContracts {
    ...ContractDetails
  }
}
    ${DeviceDetailsFragmentDoc}
${MeterDetailsFragmentDoc}
${ContractDetailsFragmentDoc}`;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    ...UserList
  }
}
    ${UserListFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const PaginateUsersDocument = gql`
    query PaginateUsers($search: String, $startIndex: Int, $count: Int, $UserFilter: UserFilter) {
  paginatedUsers(
    search: $search
    startIndex: $startIndex
    count: $count
    userFilter: $UserFilter
  ) {
    items {
      ...UserList
    }
    total
  }
}
    ${UserListFragmentDoc}`;

/**
 * __usePaginateUsersQuery__
 *
 * To run a query within a React component, call `usePaginateUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      startIndex: // value for 'startIndex'
 *      count: // value for 'count'
 *      UserFilter: // value for 'UserFilter'
 *   },
 * });
 */
export function usePaginateUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginateUsersQuery, PaginateUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginateUsersQuery, PaginateUsersQueryVariables>(PaginateUsersDocument, options);
      }
export function usePaginateUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginateUsersQuery, PaginateUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginateUsersQuery, PaginateUsersQueryVariables>(PaginateUsersDocument, options);
        }
// @ts-ignore
export function usePaginateUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaginateUsersQuery, PaginateUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaginateUsersQuery, PaginateUsersQueryVariables>;
export function usePaginateUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginateUsersQuery, PaginateUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaginateUsersQuery | undefined, PaginateUsersQueryVariables>;
export function usePaginateUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginateUsersQuery, PaginateUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaginateUsersQuery, PaginateUsersQueryVariables>(PaginateUsersDocument, options);
        }
export type PaginateUsersQueryHookResult = ReturnType<typeof usePaginateUsersQuery>;
export type PaginateUsersLazyQueryHookResult = ReturnType<typeof usePaginateUsersLazyQuery>;
export type PaginateUsersSuspenseQueryHookResult = ReturnType<typeof usePaginateUsersSuspenseQuery>;
export type PaginateUsersQueryResult = ApolloReactCommon.QueryResult<PaginateUsersQuery, PaginateUsersQueryVariables>;
export const GridOwnersDocument = gql`
    query GridOwners {
  gridOwners
}
    `;

/**
 * __useGridOwnersQuery__
 *
 * To run a query within a React component, call `useGridOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGridOwnersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GridOwnersQuery, GridOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GridOwnersQuery, GridOwnersQueryVariables>(GridOwnersDocument, options);
      }
export function useGridOwnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GridOwnersQuery, GridOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GridOwnersQuery, GridOwnersQueryVariables>(GridOwnersDocument, options);
        }
// @ts-ignore
export function useGridOwnersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GridOwnersQuery, GridOwnersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GridOwnersQuery, GridOwnersQueryVariables>;
export function useGridOwnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GridOwnersQuery, GridOwnersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GridOwnersQuery | undefined, GridOwnersQueryVariables>;
export function useGridOwnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GridOwnersQuery, GridOwnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GridOwnersQuery, GridOwnersQueryVariables>(GridOwnersDocument, options);
        }
export type GridOwnersQueryHookResult = ReturnType<typeof useGridOwnersQuery>;
export type GridOwnersLazyQueryHookResult = ReturnType<typeof useGridOwnersLazyQuery>;
export type GridOwnersSuspenseQueryHookResult = ReturnType<typeof useGridOwnersSuspenseQuery>;
export type GridOwnersQueryResult = ApolloReactCommon.QueryResult<GridOwnersQuery, GridOwnersQueryVariables>;
export const GetUserDocument = gql`
    query getUser($userId: String!) {
  user(userId: $userId) {
    ...UserDetails
    groups {
      ...GroupDetails
    }
  }
}
    ${UserDetailsFragmentDoc}
${GroupDetailsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($userid: String!) {
  deleteUser(userid: $userid)
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userid: // value for 'userid'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const SyncUserDocument = gql`
    mutation SyncUser($userId: String!) {
  syncUser(userId: $userId) {
    success
    userId
  }
}
    `;
export type SyncUserMutationFn = ApolloReactCommon.MutationFunction<SyncUserMutation, SyncUserMutationVariables>;

/**
 * __useSyncUserMutation__
 *
 * To run a mutation, you first call `useSyncUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserMutation, { data, loading, error }] = useSyncUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSyncUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncUserMutation, SyncUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncUserMutation, SyncUserMutationVariables>(SyncUserDocument, options);
      }
export type SyncUserMutationHookResult = ReturnType<typeof useSyncUserMutation>;
export type SyncUserMutationResult = ApolloReactCommon.MutationResult<SyncUserMutation>;
export type SyncUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncUserMutation, SyncUserMutationVariables>;
export const RemoveFjuttFromUserDocument = gql`
    mutation RemoveFjuttFromUser($userId: String, $fjuttId: String) {
  removeFjuttFromUser(userId: $userId, fjuttId: $fjuttId)
}
    `;
export type RemoveFjuttFromUserMutationFn = ApolloReactCommon.MutationFunction<RemoveFjuttFromUserMutation, RemoveFjuttFromUserMutationVariables>;

/**
 * __useRemoveFjuttFromUserMutation__
 *
 * To run a mutation, you first call `useRemoveFjuttFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFjuttFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFjuttFromUserMutation, { data, loading, error }] = useRemoveFjuttFromUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      fjuttId: // value for 'fjuttId'
 *   },
 * });
 */
export function useRemoveFjuttFromUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveFjuttFromUserMutation, RemoveFjuttFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveFjuttFromUserMutation, RemoveFjuttFromUserMutationVariables>(RemoveFjuttFromUserDocument, options);
      }
export type RemoveFjuttFromUserMutationHookResult = ReturnType<typeof useRemoveFjuttFromUserMutation>;
export type RemoveFjuttFromUserMutationResult = ApolloReactCommon.MutationResult<RemoveFjuttFromUserMutation>;
export type RemoveFjuttFromUserMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveFjuttFromUserMutation, RemoveFjuttFromUserMutationVariables>;
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($userid: String!, $deviceid: String!) {
  deleteDevice(userid: $userid, deviceid: $deviceid)
}
    `;
export type DeleteDeviceMutationFn = ApolloReactCommon.MutationFunction<DeleteDeviceMutation, DeleteDeviceMutationVariables>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      userid: // value for 'userid'
 *      deviceid: // value for 'deviceid'
 *   },
 * });
 */
export function useDeleteDeviceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument, options);
      }
export type DeleteDeviceMutationHookResult = ReturnType<typeof useDeleteDeviceMutation>;
export type DeleteDeviceMutationResult = ApolloReactCommon.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>;